"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon32Spinner", "spinner_32", "0 0 32 32", '<symbol viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" id="spinner_32"><path d="M16 32a1.5 1.5 0 0 1 0-3c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16c0 1.557.273 3.074.8 4.502A1.5 1.5 0 1 1 .986 21.54 15.97 15.97 0 0 1 0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16Z" fill="currentColor" /></symbol>', 32, 32);
exports.default = _default;
